import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { URL_API } from 'src/app/tools/URL';

@Injectable({
  providedIn: 'root'
})
export class AssuntoService {

  constructor(private rest: RestService) { }

  carregarAssuntosPorManifesto(manifesto) {

    return this.rest.post(`${URL_API.PATH_ASSUNTO}/carregarPorManifesto/`, manifesto);

  }

}
